function initJrbAnnouncementRotator() {
  const rotators = document.querySelectorAll('[data-jrb-announcement-rotator]');

  rotators.forEach((rotator) => {
    if (rotator.dataset.initialized === 'true') return;

    const slides = rotator.querySelectorAll('.jrb-announcement-rotator__slide');

    if (slides.length <= 1) return;

    rotator.dataset.initialized = 'true';

    let currentIndex = 0;

    slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === 0);
    });

    setInterval(() => {
      slides[currentIndex].classList.remove('is-active');

      currentIndex = currentIndex + 1;

      if (currentIndex >= slides.length) {
        currentIndex = 0;
      }

      slides[currentIndex].classList.add('is-active');
    }, 3000);
  });
}

document.addEventListener('DOMContentLoaded', initJrbAnnouncementRotator);
document.addEventListener('shopify:section:load', initJrbAnnouncementRotator);

function initBrightSkyShopTabs() {
  const sections = document.querySelectorAll('[data-brightsky-shop-tabs]');

  sections.forEach((section) => {
    const buttons = section.querySelectorAll('[data-tab-button]');
    const panels = section.querySelectorAll('[data-tab-panel]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.tabButton;

        buttons.forEach((item) => item.classList.remove('is-active'));
        panels.forEach((panel) => panel.classList.remove('is-active'));

        button.classList.add('is-active');

        const activePanel = section.querySelector(`[data-tab-panel="${id}"]`);
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  });
}
/* BrightSky Pair With button price */
function brightskyPairWithButtons() {
  document.querySelectorAll('.complementary-products .card').forEach(function (card) {
    var button = card.querySelector('.quick-add__submit');
    var price = card.querySelector('.card__information .price-item--sale, .card__information .price-item--regular, .card__information .price-item');

    if (!button || !price) return;

    var priceText = price.textContent.trim().replace(/USD|CAD|EUR|GBP/g, '').trim();
    if (!priceText) return;

    button.innerHTML =
      '<span class="quick-add-text">ADD TO BAG</span>' +
      '<span class="brightsky-pair-price">' + priceText + '</span>';
  });
}
/* BrightSky shade carousel arrows */
function brightskyShadeCarousel() {
  document.querySelectorAll('.brightsky-product-shades').forEach(function (section) {
    var carousel = section.querySelector('[data-brightsky-shades-carousel]');
    var prev = section.querySelector('.brightsky-product-shades__arrow--prev');
    var next = section.querySelector('.brightsky-product-shades__arrow--next');

    if (!carousel || !prev || !next) return;

    var getScrollAmount = function () {
      var slide = carousel.querySelector('.brightsky-product-shades__slide');
      if (!slide) return carousel.clientWidth;
      return slide.offsetWidth + 16;
    };

    prev.addEventListener('click', function () {
      carousel.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', function () {
      carousel.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', brightskyShadeCarousel);
document.addEventListener('shopify:section:load', brightskyShadeCarousel);

document.addEventListener('DOMContentLoaded', brightskyPairWithButtons);
document.addEventListener('shopify:section:load', brightskyPairWithButtons);
setTimeout(brightskyPairWithButtons, 500);
setTimeout(brightskyPairWithButtons, 1500);

document.addEventListener('DOMContentLoaded', initBrightSkyShopTabs);
document.addEventListener('shopify:section:load', initBrightSkyShopTabs);

/* BrightSky Press Quote Slider */
(function () {
  function initPressQuote(section) {
    if (!section || section.dataset.pressInitialized === 'true') return;

    const slides = Array.from(section.querySelectorAll('[data-press-slide]'));
    const triggers = Array.from(section.querySelectorAll('[data-press-trigger]'));
    const progress = section.querySelector('[data-press-progress]');

    if (!slides.length || !triggers.length) return;

    section.dataset.pressInitialized = 'true';

    let currentIndex = 0;
    let timer = null;
    const delay = 3000;

    function restartProgress() {
      if (!progress) return;

      progress.classList.remove('is-animating');
      void progress.offsetWidth;
      progress.classList.add('is-animating');
    }

    function showSlide(index) {
      currentIndex = index;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });

      triggers.forEach((trigger, triggerIndex) => {
        trigger.classList.toggle('is-active', triggerIndex === currentIndex);
      });

      restartProgress();
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(nextSlide, delay);
      restartProgress();
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const index = Number(trigger.dataset.pressTrigger || 0);
        showSlide(index);
        startAuto();
      });
    });

    section.addEventListener('mouseenter', () => {
      clearInterval(timer);
    });

    section.addEventListener('mouseleave', () => {
      startAuto();
    });

    showSlide(0);
    startAuto();
  }

  function initAllPressQuotes() {
    document.querySelectorAll('[data-press-quote]').forEach(initPressQuote);
  }

  document.addEventListener('DOMContentLoaded', initAllPressQuotes);

  document.addEventListener('shopify:section:load', function (event) {
    initAllPressQuotes();
  });
})();
/* BrightSky Shop Collections Carousel */
(function () {
  function initShopCollections(section) {
    if (!section || section.dataset.shopCollectionsInitialized === 'true') return;

    const track = section.querySelector('[data-shop-collections-track]');
    const prev = section.querySelector('[data-shop-collections-prev]');
    const next = section.querySelector('[data-shop-collections-next]');

    if (!track || !prev || !next) return;

    section.dataset.shopCollectionsInitialized = 'true';

    function getScrollAmount() {
      const card = track.querySelector('.brightsky-shop-collections__card');
      if (!card) return track.clientWidth;

      const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', function () {
      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });
  }

  function initAllShopCollections() {
    document.querySelectorAll('[data-shop-collections]').forEach(initShopCollections);
  }

  document.addEventListener('DOMContentLoaded', initAllShopCollections);

  document.addEventListener('shopify:section:load', function () {
    initAllShopCollections();
  });
})();
